import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldLocationAnswer } from '../field-geolocation-input/field-geolocation-input.component';
import { LocationService } from '../../../../utilities/location/location.service';
import { CustomFieldsMapped } from '../models/custom-field';

@Component({
  selector: 'tn-field-geolocation-detection',
  templateUrl: './field-geolocation-detection.component.html',
  styleUrls: ['./field-geolocation-detection.component.scss'],
  host: { 'component-root': 'shared' }
})
export class FieldGeolocationDetectionComponent implements OnInit {

  @Input() field: CustomFieldsMapped;
  @Input() isInput: boolean = false;

  @Output() onFieldUpdate: EventEmitter<CustomFieldsMapped> = new EventEmitter<CustomFieldsMapped>(null);

  location: FieldLocationAnswer;

  latLng;
  address;

  constructor(
    private _locationService: LocationService
  ) { }

  ngOnInit() {
    this.detectLocation();
  }

  detectLocation() {
    this._locationService.getCurrentLocation(
      (LAT_LNG) => {
        this.latLng = {
          lat: LAT_LNG.LAT,
          lng: LAT_LNG.LNG
        };
        this.getLocationAddress();
      }
    );
  }

  getLocationAddress() {
    this._locationService.getLocationAddressByLatLng(
      this.latLng,
      (address) => {
        this.address = address;
        this.onChange();
      }
    )
  }

  getAnswerValue(): string {
    this.location = {
      address: this.address,
      lat: this.latLng.lat,
      lng: this.latLng.lng
    };
    return JSON.stringify(this.location);
  }

  onChange() {
    if (!this.latLng) {
      this.detectLocation();
      return;
    }
    if (!this.address) {
      this.getLocationAddress();
      return;
    }
    this.field.answer.value = this.getAnswerValue();
    this.onFieldUpdate.emit(this.field);
  }

}
